// extracted by mini-css-extract-plugin
module.exports = {"menu":"system_menu__2D6lo","title":"system_title__TZBh-"};